import { createAction, props } from '@ngrx/store';
import { Page } from '@app/common/page';
import { OrderSummary } from '@app/common/order-summary';

export const loadAdminOrders = createAction(
  '[Admin Orders] Load Admin Orders',
  props<{ page: number, size: number, status?: string, customerQuery?: string }>()
);

export const loadAdminOrdersSuccess = createAction(
  '[Admin Orders] Load Admin Orders Success',
  props<{ orderPage: Page<OrderSummary> }>()
);

export const loadAdminOrdersFailure = createAction(
  '[Admin Orders] Load Admin Orders Failure',
  props<{ error: any }>()
);
